import { arrayOf, string, number, bool } from 'prop-types';
import { and, shape } from 'airbnb-prop-types';

const weekdayBusinessHoursType = arrayOf(
  shape({
    openTime: string.isRequired,
    closeTime: string.isRequiredy,
  }),
);

export const storeBusinessHoursShape = shape({
  mon: weekdayBusinessHoursType,
  tue: weekdayBusinessHoursType,
  wed: weekdayBusinessHoursType,
  thu: weekdayBusinessHoursType,
  fri: weekdayBusinessHoursType,
  sat: weekdayBusinessHoursType,
  sun: weekdayBusinessHoursType,
});

export const storeShape = shape({
  id: number,
  additionalLocationInfo: string,
  businessHours: storeBusinessHoursShape,
  city: string,
  erpStoreId: number,
  houseNr: string,
  lat: number,
  lng: number,
  slug: string,
  street: string,
  title: string,
  zipCode: string,
  isOutlet: bool,
});

export const storeWithDistanceShape = and([
  storeShape,
  shape({
    distance: number,
  }),
]);
